<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->

<template>
  <div class="progressbar">
    <div class="progressbar__inner">
      <div class="progressbar__progress">
        <div :style="{width: `${progress}%`}"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";

.progressbar {
  &__inner {
    border: $progressbar-border;
    background-color: $progressbar-background;
    position: relative;
    height: 100%;
  }

  &__progress {
    position: absolute;
    top: 1px;
    left: 1px;
    height: calc(100% - 2px);
    width: calc(100% - 2px);

    & > div {
      background-color: $progressbar-progress-background;
      height: 100%;
      width: 0;
      transition: all 0.25s ease-in-out;
    }
  }
}
</style>

<script>
export default {
  props: {
    progress: Number
  }
}
</script>
